import type { ApiRegistry } from "@nova/contracts"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import useSWR from "swr"

export type TAKMission =
    ApiRegistry["get /org/:orgId/integrations/tak/missions"]["outputType"][number]

const useTAKMissions = (workspaceId: string) => {
    const { data, isLoading, error } = useSWR(
        ["tak-missions", workspaceId],
        () =>
            fetchApiGateway("get /org/:orgId/integrations/tak/missions", {
                params: { orgId: workspaceId },
            }),
        { revalidateOnFocus: false, shouldRetryOnError: false }
    )

    return { missions: data, isLoading, error }
}

export { useTAKMissions }
